@if (load) {
  <div class="fixed inset-0 z-90000!">
    <div class="bg-black/30 h-screen w-full flex justify-center items-center">
      <!-- <mat-spinner></mat-spinner> -->
      <div class="loader5"></div>
    </div>
  </div>
}
